
namespace Gordic.Pod.Icons
{
    export enum ActionEnum
    {
        elPodani = "gi-ehome",
        infoODoruceni = "gi-doruc",
        odstornovatElPodani = "fa-ban",
        vratitElPodaniKeZpracovani = "fa-reply",
        odemknoutElPodani = "gi-unlock",
        actOdeslatPotvrzeniODoruceni = "gi-mail gi-stack-bg|gi-arrow g-state-text g-state-info gi-stack-fw gi-stack-fw--right-bottom gi-bgw",
    }
}

namespace Gordic.Pod.Globals
{
    export enum ActionsName {
        elPodani = "actElPodani",
        elPodaniHromadne = "actElPodaniHromadne",
        nacistMailSchranku = "actNacistMailSchranku",
        nacistDatovouSchranku = "actNacistDatovouSchranku",
        nacistDatovouSchrankuPsrSK = "actnacistDatovouSchrankuPsrSK",
        nacistDorucenkyDZ = "actNacistDorucenkyDZ",
        infoODoruceni = "actInfoODoruceni",
        odstornovatElPodani = "actOdstornovatElPodani",
        vratitElPodaniKeZpracovani = "actVratitElPodaniKeZpracovani",
        aktualizaceMetadatOvereniElPodani = "actAktualizaceMetadatOvereniElPodani",
        odemknoutElPodani = "actOdemknoutElPodani",
        sloucitZpetRozlozenaElPodani = "actSloucitZpetRozlozenaElPodani",
        odeslatPotvrzeniODoruceni = "actOdeslatPotvrzeniODoruceni",
        opravaElPodani = "actOpravaElPodani",
        vratitPoste = "actVratitPoste",
        tiskPredaneDoslePosty = "actTiskPredaneDoslePosty",
        zobrazHistoriiOvereni = "actZobrazHistoriiOvereni",
        zobrazAktualniOvereni = "actZobrazAktualniOvereni",
        zobrazZpravu = "actZobrazZpravu",
    }
}

